/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TypographyInputs */

const en_typography = /** @type {(inputs: TypographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typography`)
};

const es_typography = /** @type {(inputs: TypographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipografía`)
};

const fr_typography = /** @type {(inputs: TypographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typographie`)
};

const de_typography = /** @type {(inputs: TypographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typografie`)
};

const ja_typography = /** @type {(inputs: TypographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイポグラフィ`)
};

const zh_typography = /** @type {(inputs: TypographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排版`)
};

const ar_typography = /** @type {(inputs: TypographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الطباعة`)
};

const id_typography = /** @type {(inputs: TypographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipografi`)
};

const it_typography = /** @type {(inputs: TypographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipografia`)
};

const ru_typography = /** @type {(inputs: TypographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Типографика`)
};

const pt_typography = /** @type {(inputs: TypographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipografia`)
};

const ko_typography = /** @type {(inputs: TypographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타이포그래피`)
};

/**
* | output |
* | --- |
* | "Typography" |
*
* @param {TypographyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const typography = /** @type {((inputs?: TypographyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TypographyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_typography(inputs)
	if (locale === "es") return es_typography(inputs)
	if (locale === "fr") return fr_typography(inputs)
	if (locale === "de") return de_typography(inputs)
	if (locale === "ja") return ja_typography(inputs)
	if (locale === "zh") return zh_typography(inputs)
	if (locale === "ar") return ar_typography(inputs)
	if (locale === "id") return id_typography(inputs)
	if (locale === "it") return it_typography(inputs)
	if (locale === "ru") return ru_typography(inputs)
	if (locale === "pt") return pt_typography(inputs)
	return ko_typography(inputs)
});